import React, { useEffect } from "react";
import { connectLoginPopUp } from "./loginPopUp.connect";
import { createPortal } from "react-dom";
import { CONFIG, IS_B2C } from "../../config/api.config";
import LogInStep from "./LogInStep/LogInStep";
import SignUpTab from "./SignUpTab/SignUpTab";
import ForgotPasswordTab from "./ForgotPassword/ForgotPasswordTab";
import SVG_CloseIcon from "../../assets/images/svgs/close-dark.svg?react";
const modalRoot = document.querySelector("#modal-root");

const LoginPopUp = ({
  open,
  onDidDismiss,
  auth,
  recaptcha,
  actions,
  version,
  B2C,
  scrollPosition,
  isDetailedPromo,
  promoInfo,
  isTermCondition,
  // tab = 1
  tab = 1,
  elementsParams,
  signUp,
  logo,
}) => {
  useEffect(() => {
    if (!onDidDismiss) {
      //  setTabButton(1)
      actions.setTab(1);
    }
  }, [onDidDismiss]);

  const width =
    elementsParams && elementsParams?.clientWidth
      ? elementsParams?.clientWidth
      : window.innerWidth;

  return createPortal(
    <>
      {!!open && (
        <div
          id="popup-modal"
          className="z-[1000] absolute top-0 right-[0.5px] md:right-0 overflow-hidden flex w-full h-screen min-h-[100dvh] items-center justify-center bg-bg_CasinoPopupBg"
          onClick={() => onDidDismiss(false)} // Close modal on outside click
        >
          <div
            className="z-2 popUpBoxShadow popUpOpenAnimation absolute w-[90%] sm:w-[85%] md:w-[70%] lg:w-[550px] max-w-[550px] bg-bg_loginPopupBg p-2 xs:p-5 rounded-md"
            onClick={(e) => e.stopPropagation()} // Prevent modal clicks from closing it
          >
            <div
              className="transition-all mb-2 ease-in-out duration-200 hover:scale-105 absolute top-2 right-2"
              onClick={() => onDidDismiss(false)}
            >
              <SVG_CloseIcon />
            </div>

            <div className="w-full -mt-3 md:mt-4 my-4  flex  max-h-[30px]  items-center justify-between">
              <p className=" text-text_Ternary font-bold text-[22px]">
                {tab === 1
                  ? "Log In"
                  : tab === 2
                    ? "Sign Up"
                    : "Forgot Password"}
              </p>
              <div className="relative hidden md:flex overflow-hidden  max-h-[30px] max-w-[141.428571429px]   items-center justify-end">
                {IS_B2C && (
                  <img
                    className="lg:h-[35px] h-[20px]"
                    src={logo}
                    alt="register banner"
                  />
                )}
              </div>
            </div>

            {tab === 1 && <LogInStep onDidDismiss={onDidDismiss} />}

            {(CONFIG.showSignupOption ||
              (CONFIG.showSignupbyRefer && !!signUp.referCode)) &&
              tab === 2 && <SignUpTab onDidDismiss={onDidDismiss} />}

            {tab === 3 && (
              <ForgotPasswordTab onDidDismiss={onDidDismiss} width={width} />
            )}
          </div>
        </div>
      )}
    </>,
    modalRoot,
  );
};

export default connectLoginPopUp()(LoginPopUp);
